// src/components/Header.js
import React from 'react';
import './Header.css';
import logo from '../assets/logo.png'; // Or use '/logo.png' if from public/

const Header = () => {
  return (
    <header className="global-header">
      <img src={logo} alt="Company Logo" className="logo" />
    </header>
  );
};

export default Header;
